import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface RequestParams {
  /** 确认密码 */
  confirm_pwd?: string
  /** 原始密码 */
  original_pwd?: string
  /** 密码 */
  password?: string
}

@Injectable()
export class UpdatePasswordService {
  constructor (private http: Http) {}

  updatePassword (data: RequestParams) {
    return this.http.post('/user/update/password', data)
  }
}
